import { render, staticRenderFns } from "./noLogo.vue?vue&type=template&id=6a2106f4"
import script from "./noLogo.vue?vue&type=script&lang=js"
export * from "./noLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports